/**
 * Utilidad pura para formateo inteligente de tiempos y duraciones de llamadas
 * Cumple con Clean Code y Single Responsibility Principle (SRP).
 */

/**
 * Convierte segundos numéricos o strings preformateados a formato alineado 00:00 con sufijo dinámico:
 * - Menos de 60 segundos: "00:SS seg" (ej: "00:29 seg", "00:00 seg", "00:13 seg")
 * - 60 segundos o más: "mm:ss min" (ej: "01:11 min", "05:20 min")
 *
 * @param {number|string} segundos Cantidad de segundos numéricos (ej: 29)
 * @param {string} [fallback] String alternativo recibido del backend (ej: "00:29 min")
 * @returns {string} Texto formateado limpio con alineación uniforme 00:00
 */
export function formatDuracionLegible(segundos, fallback = '') {
  // 1. Si viene el valor en segundos numérico
  if (segundos !== undefined && segundos !== null && segundos !== '') {
    const total = Number(segundos);
    if (!isNaN(total)) {
      if (total <= 0) return '00:00 seg';
      if (total < 60) return `00:${String(total).padStart(2, '0')} seg`;
      const mins = Math.floor(total / 60);
      const secs = total % 60;
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')} min`;
    }
  }

  // 2. Si solo tenemos el fallback string (ej: "00:29 min" o "29 seg" o "01:11 min")
  if (typeof fallback === 'string' && fallback.trim()) {
    const match = fallback.trim().match(/^(\d+):(\d+)(?:\s*(?:min|seg))?$/i);
    if (match) {
      const mins = parseInt(match[1], 10);
      const secs = parseInt(match[2], 10);
      const total = mins * 60 + secs;
      if (total <= 0) return '00:00 seg';
      if (total < 60) return `00:${String(total).padStart(2, '0')} seg`;
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')} min`;
    }

    const singleMatch = fallback.trim().match(/^(\d+)\s*(?:seg|s)$/i);
    if (singleMatch) {
      const total = parseInt(singleMatch[1], 10);
      if (total <= 0) return '00:00 seg';
      if (total < 60) return `00:${String(total).padStart(2, '0')} seg`;
      const mins = Math.floor(total / 60);
      const secs = total % 60;
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')} min`;
    }

    return fallback;
  }

  return '00:00 seg';
}

